/**
 * Values for the `autoComplete` prop of `CustomInput` / antd `Input`.
 *
 * These map to the HTML autofill field names (WHATWG HTML §autofill), with one
 * project-specific addition: `OFF_AUTOCOMPLETE`. Chromium ignores a plain
 * `autocomplete="off"` on inputs it thinks it recognises, so an unrecognised
 * token is used instead to suppress autofill on sensitive fields (NRIC/FIN,
 * masked identifiers, free-text answers).
 *
 * Only the tokens currently used in the app are listed — add more from the
 * spec as they are needed.
 */
const AUTO_COMPLETE = {
  /** Hint only: browsers routinely ignore it, so prefer `OFF_AUTOCOMPLETE` on sensitive inputs. */
  OFF: 'off',
  /** Use on sensitive fields (NRIC/FIN, identifiers) — browsers honour it where `off` is ignored. */
  OFF_AUTOCOMPLETE: 'off_autocomplete',

  ADDRESS_LINE2: 'address-line2',
  ADDRESS_LINE3: 'address-line3',
  EMAIL: 'email',
  NAME: 'name',
  ONE_TIME_CODE: 'one-time-code',
  POSTAL_CODE: 'postal-code',
} as const;

export { AUTO_COMPLETE };
